import { createTheme, MantineColorsTuple } from '@mantine/core';

// Brand-aligned violet (close to existing #9c27b0 clientell purple, softened)
const brandViolet: MantineColorsTuple = [
  '#f4f0ff',
  '#e3dafd',
  '#c3b2f5',
  '#a288ee',
  '#8666e8',
  '#7551e5',
  '#6b46e3',
  '#5938ca',
  '#4e30b5',
  '#41279f',
];

// Soft neutral grays (warmer than MUI defaults)
const slate: MantineColorsTuple = [
  '#f8fafc',
  '#f1f5f9',
  '#e2e8f0',
  '#cbd5e1',
  '#94a3b8',
  '#64748b',
  '#475569',
  '#334155',
  '#1e293b',
  '#0f172a',
];

export const mantineTheme = createTheme({
  fontFamily:
    "'Inter Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontFamilyMonospace:
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  headings: {
    fontFamily:
      "'Inter Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontWeight: '700',
    sizes: {
      h1: { fontSize: '3.25rem', lineHeight: '1.15', fontWeight: '800' },
      h2: { fontSize: '2.5rem', lineHeight: '1.2', fontWeight: '700' },
      h3: { fontSize: '2rem', lineHeight: '1.3', fontWeight: '700' },
      h4: { fontSize: '1.5rem', lineHeight: '1.35', fontWeight: '600' },
      h5: { fontSize: '1.25rem', lineHeight: '1.4', fontWeight: '600' },
      h6: { fontSize: '1rem', lineHeight: '1.5', fontWeight: '600' },
    },
  },
  colors: {
    brand: brandViolet,
    slate,
  },
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 7 },
  defaultRadius: 'md',
  radius: {
    xs: '6px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },
  shadows: {
    xs: '0 1px 2px rgba(15, 23, 42, 0.04)',
    sm: '0 2px 6px rgba(15, 23, 42, 0.06)',
    md: '0 6px 16px rgba(15, 23, 42, 0.08)',
    lg: '0 12px 28px rgba(15, 23, 42, 0.10)',
    xl: '0 24px 48px rgba(15, 23, 42, 0.14)',
  },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 600,
          letterSpacing: '-0.005em',
        },
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
      },
    },
    Modal: {
      defaultProps: {
        radius: 'md',
        centered: true,
      },
      styles: {
        title: {
          fontWeight: 700,
          fontSize: '1.1rem',
        },
        header: {
          borderBottom: '1px solid #eef0f6',
          paddingBottom: 12,
          marginBottom: 4,
        },
      },
    },
  },
});
